(function () {
  const formatRupees = (value) => {
    const amount = Number(value || 0);
    const hasPaise = Math.round(amount * 100) % 100 !== 0;
    return `₹${amount.toLocaleString('en-IN', {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: hasPaise ? 2 : 0,
    })}`;
  };

  const normalizeMoneyText = (value) => String(value || '').replace(
    /(?:INR|Rs\.?|₹)\s*([\d,]+(?:\.\d{1,2})?)/gi,
    (match, amount) => formatRupees(Number(String(amount).replace(/,/g, '')))
  );

  const normalizeMoneyElements = (root) => {
    const elements = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('.money')) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll('.money'));

    elements.forEach((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        const normalized = normalizeMoneyText(node.nodeValue);
        if (normalized !== node.nodeValue) node.nodeValue = normalized;
        node = walker.nextNode();
      }
    });
  };

  const normalizeForFourSeconds = () => {
    let checks = 0;
    const timer = window.setInterval(() => {
      normalizeMoneyElements(document);
      checks += 1;
      if (checks >= 40) window.clearInterval(timer);
    }, 100);
  };

  normalizeMoneyElements(document);

  new MutationObserver(() => normalizeMoneyElements(document)).observe(
    document.body,
    { childList: true, subtree: true, characterData: true }
  );

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-tie-cart-page-change], [data-tie-add-to-cart], [data-tie-side-cart] button')) {
      normalizeForFourSeconds();
    }
  }, true);
})();
